import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import TagManager from 'react-gtm-module'
import {
  useUserService,
  useErrorService,
  OverviewProsperitySurveyResults,
  surveyType,
} from '@abroad/components'
import LearnMoreBtnEvent from '../../constants/events'
import FullResultEvent from '../../constants/events'
import API from '../../utils/API'
import { CustomAssessmentShimmer } from '../common'

const questProsperityTitles = {
  lifeWork: 'Life &\nWork',
  selfAwareness: 'Self\nAwareness',
  timelessWisdom: 'Timeless\nWisdom',
}

const type = 'personal'

export default function QuestProsperityResult() {
  const history = useHistory()
  const [QuestSurveyResult, setQuestSurveyResult] = useState()
  const [recentSurveyLoader, setRecentSurveyLoader] = useState(true)
  const [surveyId, setSurveyId] = useState(null)
  const { user } = useUserService()
  const Error = useErrorService()

  useEffect(() => {
    const fetchSurveyId = async () => {
      try {
        setRecentSurveyLoader(true)
        const { data } = await API.survey.getSurveys(
          type,
          surveyType.PROSPERITY,
        )
        if (data?.surveys?.length) {
          const latestSuveyIndex = data.surveys.length - 1
          setSurveyId(data.surveys[latestSuveyIndex]?._id)
        } else {
          setRecentSurveyLoader(false)
        }
      } catch (e) {
        Error.showError(e)
        setRecentSurveyLoader(false)
      }
    }

    fetchSurveyId()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    const fetchSurveyDetails = async () => {
      if (!surveyId) return

      try {
        setRecentSurveyLoader(true)
        const { data } = await API.survey.getSurveyById(surveyId)
        if (data) {
          setQuestSurveyResult(data)
        }
      } catch (e) {
        Error.showError(e)
      } finally {
        setRecentSurveyLoader(false)
      }
    }
    fetchSurveyDetails()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [surveyId])

  const gtmLearnMoreBtnClickedAction = (categoryId) => {
    TagManager.dataLayer({
      dataLayer: {
        event: LearnMoreBtnEvent.event.learnMore,
        eventProps: {
          category: LearnMoreBtnEvent.category.learnMoreCategory,
          action: 'User click on learnMore button',
          label: 'click on learnMore button',
          value: categoryId,
          userId: user?._id,
        },
      },
    })
  }

  const gtmSeeFullResultAction = () => {
    TagManager.dataLayer({
      dataLayer: {
        event: FullResultEvent.event.seeFullResult,
        eventProps: {
          category: FullResultEvent.category.seeFullResultCategory,
          action: 'User click on see full result button',
          label: 'click on see full result button',
          value: 'User click on see full result button',
          userId: user?._id,
        },
      },
    })
  }

  if (recentSurveyLoader) {
    return (
      <div className='mb-52px m-3'>
        <CustomAssessmentShimmer />
      </div>
    )
  }

  if (!QuestSurveyResult) {
    return null
  }

  return (
    <>
      <div className='mt-32px mb-3 d-flex flex-row justify-content-between align-items-center quest-prosperity-results-header'>
        <div className='s4 mb-0'>Assessment Results</div>
        <div
          className='s11 font-saffron-700 cursor-pointer quest-prosperity-see-full'
          onClick={() => {
            gtmSeeFullResultAction()
            history.push(`/prosperity/${QuestSurveyResult?.id}`, {
              isComeFrom: 'your-experiences',
            })
          }}>
          See Full Results
        </div>
      </div>
      <div className='quest-prosperity-results'>
        <OverviewProsperitySurveyResults
          survey={QuestSurveyResult}
          onLearnMoreClick={gtmLearnMoreBtnClickedAction}
          titleClasses='quest-prosperity-result-title'
          linkClasses='s11 mt-4 mb-0 text-dark-900-5 cursor-pointer quest-prosperity-learn-more'
          titles={questProsperityTitles}
        />
      </div>
    </>
  )
}
